export function capitalizeInitial(s: string): string {
  return s.charAt(0).toUpperCase() + s.substr(1);
}
